import React, { useState, Suspense, useRef } from 'react';
import NotificationTemplateForm from 'features/crm/components/notification-templates/NotificationTemplateForm';
import NotificationTemplatesList from 'features/crm/components/notification-templates/NotificationTemplatesList';
import Tooltip from 'shared/ui/Tooltip';
import Loading from 'shared/ui/Loading';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { Info } from 'lucide-react';




const NotificationTemplates = () => {
  const { currentColor } = useStateContext();
  const { openModal } = useLayout();
  const listRef = useRef(null);

  const handleRefreshList = () => {
    listRef.current?.refresh();
  };

  const handleAddNotificationTemplate = () => {
    openModal({
      component: <NotificationTemplateForm refreshList={handleRefreshList} />,
      title: 'Добавить рассылку',
    });
  };
  return (
    <>
      <Suspense fallback={<Loading/>}>

      <div className='bg-gray-100 py-4 px-6 flex justify-between items-center relative'>
        <div className='flex items-center relative'>
          <Tooltip content={'Here will be related info'} trigger='click' className='mr-2'>
            <button className='text-gray-700 hover:text-gray-900 mr-2 mt-1'>
              <Info size={20} />
            </button>
          </Tooltip>
          <h1 className='text-2xl font-bold'>Рассылки</h1>
          
        </div>
        <div className='flex items-center'>
          <button className=' text-white px-4 py-2 rounded-md hover:' style={{ backgroundColor: currentColor }} onClick={() => handleAddNotificationTemplate()}>
            + Рассылка
          </button>
        </div>
      </div>
        
        <NotificationTemplatesList ref={listRef} />
      </Suspense>
    </>
  );
};

export default NotificationTemplates;
